import { apiWrapper } from 'ccs-ui-components';
import { IDeleteResponse } from '../models/IDeleteResponse';
import { headersInstance } from '../utils/HeaderUtils';

/**
 * @method useDeleteEntity
 * @description Custom hook to make delete API call
 * @returns delete api response
 */
const useDeleteEntity = () => {
  const deleteEntity = async (deleteURL: string) => {
    const resp = await apiWrapper.delete<IDeleteResponse, { errorMessage: string }>(
      `${process.env.REACT_APP_API_CONTROL_PLANE_SERVICE_BASE_URL}/${deleteURL}`,
      headersInstance()
    );

    if (resp.isError) {
      return {
        errorMessage: resp.errorBody?.errorMessage,
        isError: true,
        statusCode: resp.statusCode
      };
    }
    const deleteResponse = resp.responseBody;
    return {
      deleteResponse,
      isError: resp.isError,
      statusCode: resp.statusCode
    };
  };

  return { deleteEntity };
};

export default useDeleteEntity;
